import { DOCUMENT_CATEGORY_LOCALIZE_MAP } from 'services/documents/ts/constants';
import { t } from 'ttag';

import { ConditionOptionKey, ConditionsKey, MenuItem } from './types';

export const MENU_ITEMS: MenuItem[] = [
    {
        id: 'general',
        title: t`Загальні дані`,
    },
    {
        id: 'conditions',
        title: t`Умови`,
    },
    {
        id: 'reviewers',
        title: t`Співробітники, що мають погодити документи`,
    },
    {
        id: 'signers',
        title: t`Cпівробітники, що мають підписати документи`,
    },
    {
        id: 'viewers',
        title: t`Доступ співробітників до документів`,
    },
    {
        id: 'fields',
        title: t`Додаткові параметри`,
    },
    {
        id: 'tags',
        title: t`Ярлики`,
    },
];

export const ConditionOptions: {
    value: ConditionOptionKey;
    label: string;
    hint?: string;
    disabled: boolean;
}[] = [
    {
        disabled: false,
        value: 'remove',
        label: `― ${t`Прибрати умову`} ―`,
    },
    {
        disabled: false,
        value: '#document_side',
        label: t`Вхідний, вихідний, внутрішній`,
    },
    {
        disabled: false,
        value: '#document_recipients.edrpou',
        label: t`ЄДРПОУ/ІПН контрагента`,
    },
    {
        disabled: false,
        value: '#document_sign_process',
        label: t`Порядок підписання`,
    },
    {
        disabled: false,
        value: '#document_category',
        label: t`Тип документа`,
    },
    {
        disabled: false,
        value: '#document_uploaded_by',
        label: t`Користувачі, що завантажили документ`,
    },
    {
        disabled: false,
        hint: t`Данна умова не сумісна з умовами "Вихідний" та "Внутрішній"`,
        value: '#document_recipients.email',
        label: t`Користувачі, що отримали документ`,
    },
    {
        value: '#document_amount',
        label: t`Сума документа`,
        disabled: false,
    },
];

export const DocumentSideOptions: {
    disabled: boolean;
    value: string;
    label: string;
    hint?: string;
}[] = [
    {
        disabled: false,
        value: 'inbox',
        label: t`Вхідний`,
    },
    {
        hint: t`Данна умова не сумісна з умовою "Користувачі, що отримали документ"`,
        disabled: false,
        value: 'internal',
        label: t`Внутрішній`,
    },
    {
        hint: t`Данна умова не сумісна з умовою "Користувачі, що отримали документ"`,
        disabled: false,
        value: 'outbox',
        label: t`Вихідний`,
    },
];

export const DocumentSignProcessOptions: { value: string; label: string }[] = [
    {
        value: 'internal',
        label: t`Внутрішній`,
    },
    {
        value: 'bilateral',
        label: t`Двосторонній`,
    },

    {
        value: 'multilateral',
        label: t`Багатосторонній`,
    },
];

export const ConditionValueText: Partial<
    Record<ConditionsKey, Record<string, string>>
> = {
    '#document_sign_process': {
        internal: t`Внутрішній`,
        bilateral: t`Двосторонній`,
        multilateral: t`Багатосторонній`,
    },
    '#document_side': {
        inbox: t`Вхідний`,
        internal: t`Внутрішній`,
        outbox: t`Вихідний`,
    },
    '#document_category': {
        ...DOCUMENT_CATEGORY_LOCALIZE_MAP,
    },
};

export const ConditionKeyMultipleOccurrenceText: Partial<
    Record<ConditionsKey, string>
> = {
    '#document_sign_process': t`Сценарій спрацює, якщо контрагент матиме один із вказаних ЄДРПОУ\\ІПН.`,
    '#document_side': t`Сценарій спрацює, якщо документ матиме один із вказаних порядків підписання.`,
    '#document_recipients.edrpou': t`Сценарій спрацює, якщо документ належатиме до одного із вказаних розділів.`,
    '#document_category': t`Сценарій спрацює, якщо документ належатиме до одного із вказаних типів.`,
};

export enum ConditionsFormInputIds {
    DOCUMENT_RECIPIENT_EDRPOU = '#document_recipients.edrpou',
    DOCUMENT_SIDE = '#document_side',
    DOCUMENT_SIGN_PROCESS = '#document_sign_process',
    DOCUMENT_CATEGORY = '#document_category',
    DOCUMENT_UPLOADED_BY = '#document_uploaded_by',
    DOCUMENT_RECIPIENT_EMAIL = '#document_recipients.email',
}

export const TEMPLATES_PER_PAGE_OPTIONS: {
    value: number;
    label: string;
}[] = [
    {
        value: 10,
        label: '10',
    },
    {
        value: 20,
        label: '20',
    },
    {
        value: 50,
        label: '50',
    },
];
